<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>{{ repairerUserName ? 'Sharing ' + repairerUserName + "'s screen" : 'Sharing screen' }}</h6>
    <button matButton="elevated" class="red-button" aria-label="Close" mat-dialog-close (click)="stoppingScreenShare()">
      <mat-icon>close</mat-icon>
      STOP SHARING SCREEN
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<div mat-dialog-content>
  @if (waitingForScreenShare() && !screenSharePaused()) {
    <div class="progress-bar">
      <mat-icon>screen_share</mat-icon>
      <h5>Request Screen Sharing</h5>
      <div class="w-[300px] inline-block">
        <mat-progress-bar mode="buffer" />
        @if (cobrowsingUsers().length) {
          <div class="body-2 mt-10">
            @if (!waitingRepUserConfirmation()) {
              <div>
                <span class="bold"
                  >{{ cobrowsingUsers().length | i18nPlural: cobrowsingUsersPluralMapping }} online,</span
                >
                please select who you would like to share your screen with.
              </div>
            } @else {
              Waiting for <span class="bold">{{ selectedCobrowsingUser() }}</span> to confirm share screen.
            }
          </div>
        } @else {
          <div class="body-2 mt-10">There are no users online, please contact the repairer.</div>
        }
      </div>
      @if (!waitingRepUserConfirmation()) {
        <cobrowsing-user (sendRequestShare)="subscribeToScreenShare($event)" [cobrowsingUsers]="cobrowsingUsers()" />
      }
    </div>
  }
  @if (screenSharePaused() && !waitingForScreenShare()) {
    <div class="paused-screen">
      <mat-icon svgIcon="sharing_paused" />
      <h5>Screen sharing paused</h5>
      <mat-progress-bar mode="buffer" />
      <div class="waiting-message body-2">
        <span>The shared screen is no longer actively displayed</span>
      </div>
    </div>
  }
  <video class="host" [class.hide-host]="waitingForScreenShare() || screenSharePaused()" playsinline autoplay #host>
    Sorry, your browser doesn't support embedded videos.
  </video>
</div>
